import createActivityDetector from 'activity-detector';
import useEffectOnLoad from './useEffectOnLoad';

function useIdle(timeToIdleInMins, onIdle, onActive = null) {
    const timeToIdleInMs = timeToIdleInMins * 60000;
    useEffectOnLoad(() => {
        let result;
        if (timeToIdleInMs !== 0) {
            const activityDetector = createActivityDetector({ timeToIdle: timeToIdleInMs, inactivityEvents: [], ignoredEventsWhenIdle: [] });
            activityDetector.on('idle', onIdle);
            if (onActive) {
                activityDetector.on('active', onActive);
            }
            result = () => activityDetector.stop();
        }
        return result;
    });
}

export default useIdle;
